import React from "react";
import { Spin, Empty } from "antd";
import Datacard from "./Datacard";
import Pagination from "../../NewComponent/Pagination/Pagination";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action/index";
export default function RenderTermData() {
  const termState = useSelector((state) => state.keyTerm);
  const dispatch = useDispatch();
  const { keyTermDataPageNoUpdate } = bindActionCreators(Actions, dispatch);
  const onChangePage = (key) => {
    keyTermDataPageNoUpdate(key - 1);
  };
  return (
    <>
      {termState.isLoading && (
        <div className="mt-3">
          <Spin size="large">
            <div style={{ height: "100px" }}></div>
          </Spin>
        </div>
      )}
      {!termState.isLoading && termState.data2.length === 0 && (
        <div className="mt-3">
          <Empty />
        </div>
      )}
      {!termState.isLoading && termState.data2.length !== 0 && (
        <div className="mt-3">
          {termState.data2.map((term, index) => {
            return <Datacard key={index} id={index + 1} data={term} />;
          })}
        </div>
      )}
      {!termState.isLoading && <div style={{ display: "flex", justifyContent:'end' }}>
        <Pagination
          page={termState.pageNo + 1}
          onChangeFunc={onChangePage}
          total={termState.totalCount}
        />
      </div>}
    </>
  );
}
